import script from "./LegendSwitch.vue?vue&type=script&lang=ts&setup=true"
export * from "./LegendSwitch.vue?vue&type=script&lang=ts&setup=true"

import "./LegendSwitch.vue?vue&type=style&index=0&id=f3ff7efe&lang=css"

const __exports__ = script;

export default __exports__